import { observable } from "mobx";
import AccountingDocumentsInventoryCheckActionRejectionReason from "./accountingDocumentsInventoryCheckActionRejectionReason";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class AccountingDocumentsInventoryCheckActionResponse {
  @observable
  isAllowed!: boolean;

  @observable
  rejectionReason?: AccountingDocumentsInventoryCheckActionRejectionReason;
}
